import { useEffect, useState } from 'react';
import { listarMapeamento, aplicarTemplateMapa } from '../api';
import { PageHeader, Loading, Empty, Alert } from '../components/common';

export default function Mapeamento({ clienteId }) {
  const [mapa, setMapa] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState(null);

  const carregar = () => {
    if (!clienteId) return;
    setLoading(true);
    listarMapeamento(clienteId)
      .then(r => setMapa(r.items || []))
      .catch(err => setMsg({ tipo: 'danger', txt: err.message }))
      .finally(() => setLoading(false));
  };
  useEffect(carregar, [clienteId]);

  const aplicar = async () => {
    if (!confirm('Aplicar template default (20 categorias comuns)?')) return;
    try {
      const r = await aplicarTemplateMapa(clienteId);
      setMsg({ tipo: 'success', txt: `${r.aplicados} mapeamento(s) inserido(s)` });
      carregar();
    } catch (err) {
      setMsg({ tipo: 'danger', txt: err.message });
    }
  };

  if (!clienteId) return <Empty title="Selecione um cliente" />;

  return (
    <>
      <PageHeader
        title="Mapeamento Finance → Contábil"
        sub="Categoria do Finance vira par D/C contábil no lançamento automático"
        actions={<button onClick={aplicar}>↓ Aplicar template default</button>}
      />

      {msg && <Alert tipo={msg.tipo}>{msg.txt}</Alert>}

      <div className="card">
        {loading ? <Loading /> : mapa.length === 0 ? (
          <Empty title="Sem mapeamentos" sub="Aplique o template default pra começar." />
        ) : (
          <table className="data">
            <thead>
              <tr>
                <th>Categoria Finance</th>
                <th>Tipo</th>
                <th>Débito</th>
                <th>Crédito</th>
              </tr>
            </thead>
            <tbody>
              {mapa.map(m => (
                <tr key={m.id}>
                  <td className="bold">{m.categoria_finance}</td>
                  <td>
                    <span className={`badge badge--${m.tipo_movimento === 'R' ? 'success' : 'info'}`}>
                      {m.tipo_movimento === 'R' ? 'Receita' : 'Despesa'}
                    </span>
                  </td>
                  <td>
                    <div className="small" style={{ fontFamily: 'monospace' }}>{m.conta_debito_codigo || '—'}</div>
                    <div className="small muted">{m.conta_debito_nome || ''}</div>
                  </td>
                  <td>
                    <div className="small" style={{ fontFamily: 'monospace' }}>{m.conta_credito_codigo || '—'}</div>
                    <div className="small muted">{m.conta_credito_nome || ''}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
